export class Login {
  constructor(difference) {
    this.createBlockTimes = 0
    this.styleName = "1"
    this.isSystemComponent = true
    this.isDefaultComponent = true
    this.isCustomComponent = true //定制组件
    this.isIndependenceComponent = true //toolbar-option-components 没有单独的设置项
    this.innerElement = "emptyLayoutComponent"
    this.name = "登录框"
    this.width = 456
    this.height = 551
    this.top = 10
    this.left = 10
    this.moduleId = ""
    this.appId = ""
    this.isCache = true
    this.isShowTabs = true
    this.isShowTitle = true
    this.isShowMoreBtn = true
    this.activeIndex = 0
    this.borderTopLeftRadius = 12
    this.borderTopRightRadius = 12
    this.borderBottomLeftRadius = 12
    this.borderBottomRightRadius = 12
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 0
    this.boxShadowColor = "rgba(10, 31, 74, 0.1)"
    this.boxShadowH = [0]
    this.boxShadowV = [4]
    this.boxShadowBlur = [24]
    this.boxShadowSpread = [0]
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.noCacheComponent = false
    this.updateTimer = 100
    this.reverseGetColsUid = false
    this.titleOptionsWidth = 80
    this.titleOptionsHeight = 192
    this.phoneLogin = true
    this.codeLogin = true
    this.schoolLogin = false
    this.testLogin = false
    this.titleOptions = [
      {
        type: "top",
        elementOptions: []
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ]
    this.rows = [
      {
        height: "100%",
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          //width加起来不能大于12
          {
            uid: "emptyLayoutComponentRootBox",
            alignSelf: "stretch",
            width: "100%",
            component: null,
            elementOptions: [],
            componentBoxOptions: {
              padding: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              borderStyle: "dashed", // solid, dashed, dotted
              borderColor: "rgba(96,100,106,1)",
              borderWidth: 1,
              clipSize: "cover",
              repeatType: "no-repeat",
              alignType: "center center",
              imgSrc: "",
              opacity: 100,
              animateSets: {
                animateType: 0,
                animateDirection: "无",
                animateDuration: 1.5,
                animateDelay: 0,
                hasDirection: false,
                animateTriggerNumType: "单次触发",
                animateClass: "",
                executionAnimateClass: ""
              }
            }
          }
        ]
      }
    ]
    this.doubleFactor = false
    this.alonePassword = false
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
